import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=44f1333c"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=44f1333c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports